
import React from "react";
const InfoIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={19}
    fill="none"
    {...props}
  >
    <path
      stroke="#8065C9"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M9.5 13.748v-5.1"
    />
    <path
      fill="#8065C9"
      d="M9.498 5.25a.85.85 0 1 1 0 1.7.85.85 0 0 1 0-1.7Z"
    />
    <path
      stroke="#8065C9"
      strokeWidth={1.2}
      d="M1 9.5c0-4.007 0-6.01 1.244-7.256C3.49 1 5.494 1 9.5 1c4.007 0 6.01 0 7.255 1.244C18 3.49 18 5.494 18 9.5c0 4.007 0 6.01-1.245 7.255C15.51 18 13.507 18 9.5 18s-6.01 0-7.256-1.245C1 15.51 1 13.507 1 9.5Z"
    />
  </svg>
);

export default InfoIcon;
